import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Snackbar, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import ErrorIcon from '@mui/icons-material/Error';
const CreateAreaModal = ({ iscreateArea, setIscreateArea, handleConfirmCreateArea, locationData, areaNullError, buttonloading, setAreaNullError }) => {





  const [createAreaDetails, setCreateAreaDetails] = useState({
    status: 1,
    location: "",
    area: ""
  })

  const handleChange = (e) => {
    const { name, value } = e.target

    setCreateAreaDetails((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }


  const handleClose = () => {
    setIscreateArea(false)
    setAreaNullError(false)
    setCreateAreaDetails((prevState) => ({
      ...prevState,
      status: 1,
      location: null,
      area: ""
    }))
  }



  return (
    <>
      <Dialog open={iscreateArea} onClose={() => handleClose()} fullWidth>
        <DialogTitle>Create Area</DialogTitle>
        <DialogContent sx={{ m: 2 }}>



          <FormControl fullWidth >
            <InputLabel id="demo-simple-select-label">Location</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="location"
              label="Location"
              onChange={(e) => handleChange(e)}

            >
              {
                locationData.map((locData) => (
                  <MenuItem value={locData._id}>{locData.location}</MenuItem>
                ))
              }
            </Select>
          </FormControl>

          <TextField
            label="Area"
            type="text"
            fullWidth
            variant="outlined"
            sx={{ margin: "10px 0" }}
            name="area"
            onChange={(e) => handleChange(e)}
          />


          <FormControl fullWidth sx={{ margin: "10px 0" }}>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="status"
              onChange={(e) => handleChange(e)}
              label="Status"
              value={createAreaDetails.status}
            >
              <MenuItem value={0}>Inactive</MenuItem>
              <MenuItem value={1}>Active</MenuItem>
            </Select>
          </FormControl>


          {/* {
            areaNullError && <Box sx={{ display: "flex", alignItems: "center", gap: "5px", margin: "10px 0", color: 'red' }}>
              <ErrorIcon />
              <Typography>Please fill all fields</Typography>
            </Box>
          } */}

          <Snackbar open={areaNullError}
            autoHideDuration={6000}
            onClose={() => setAreaNullError(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert onClose={() => setAreaNullError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
              Please fill all fields
            </Alert>
          </Snackbar>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()}>Cancel</Button>
          <Button onClick={() => handleConfirmCreateArea(
            createAreaDetails.location,
            createAreaDetails.area,
            createAreaDetails.status
          )}
            disabled={buttonloading}
          >
            {
              buttonloading ? <CircularProgress size={15} color='primary' /> : 'Create'
            }
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CreateAreaModal